import { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { ArrowLeft } from "lucide-react";
import { API } from "../App";
import { renderMarkdownSafe } from "../lib/safeMarkdown";

const TITLES = {
  privacy: "Privacy Policy",
  terms: "Conditions of Service",
  cancellation: "Cancellation Policy",
  cookies: "Cookie Policy"
};

const SLUG_MAP = {
  privacy: "privacy",
  terms: "terms_of_service",
  cancellation: "cancellation_policy",
  cookies: "cookie_policy"
};

export default function LegalPage({ defaultSlug = "privacy" }) {
  const { slug: pathSlug } = useParams();
  const slug = pathSlug || defaultSlug;
  const apiSlug = SLUG_MAP[slug] || "privacy";
  const title = TITLES[slug] || "Legal";

  const [content, setContent] = useState("");
  const [updatedAt, setUpdatedAt] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios.get(`${API}/legal/${apiSlug}`)
      .then(res => { setContent(res.data.content_md); setUpdatedAt(res.data.updated_at); })
      .catch((err) => {
        console.error(`Failed to load legal page (${apiSlug})`, err);
        setContent(`# ${title}\n\nUnable to load.`);
      })
      .finally(() => setLoading(false));
  }, [apiSlug, title]);

  const safeHtml = useMemo(() => ({ __html: renderMarkdownSafe(content) }), [content]);

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <header className="border-b border-white/5 p-6">
        <div className="max-w-3xl mx-auto flex items-center justify-between">
          <Link to="/" className="text-2xl font-bold logo-text">TAXINEARME</Link>
          <Link to="/" className="text-white/60 hover:text-[#C5A059] flex items-center gap-2 text-sm">
            <ArrowLeft className="w-4 h-4" /> Back to home
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto p-6 lg:p-12" data-testid={`legal-page-${slug}`}>
        {loading ? (
          <div className="flex justify-center py-20"><div className="spinner" /></div>
        ) : (
          <>
            <article className="prose-custom" dangerouslySetInnerHTML={safeHtml} />
            {updatedAt && (
              <p className="mt-12 text-white/30 text-xs italic">Last updated: {updatedAt.slice(0, 10)}</p>
            )}
          </>
        )}
      </main>
    </div>
  );
}
